export default __webpack_public_path__ + "static/banner-manage-your-finances-6009ae7f26808b2c0bbef1983e1654e4.jpg";